<template>
  <div class="dreambooks">
    <!-- menu -->
    <nav class="horoscope__nav horoscope-nav" :class="{'sticky': sticky}">
      <div class="container horoscope-nav__container">
        <div class="row no-gutters horoscope-nav__row">
          <a
            href="#"
            role="button"
            class="horoscope-nav__item horoscope-nav__item--active"
            @click.prevent="openFirstMenu = !openFirstMenu"
            :class="{'zindex': openFirstMenu}"
          >
            <img src="../assets/img/chiromancy.png">
          </a>
          <a
            href="#"
            role="button"
            class="horoscope-nav__item"
            @click.prevent="openSecondMenu = !openSecondMenu"
            :class="{'zindex': openSecondMenu}"
          >
            <img src="../assets/img/btn.png" alt="Кнопка" class="animated-shadow">
          </a>
        </div>

        <transition name="fade">
          <nav
            class="horoscope__menu horoscope-menu horoscope-menu--first"
            v-if="openFirstMenu"
            @click="openFirstMenu = !openFirstMenu"
          >
            <router-link v-for="(item, index) in firstMenu" :key="index" :to="`/${item.id}/`">
              <img :src="require(`../assets/img/${item.id}.png`)" :alt="item.name">
              {{item.name}}
            </router-link>
          </nav>
        </transition>

        <transition name="fade">
          <nav
            class="horoscope__menu horoscope-menu horoscope-menu--second"
            v-if="openSecondMenu"
            @click="openSecondMenu = !openSecondMenu"
          >
            <router-link
              v-for="(item, index) in chiromancySecondMenu"
              :key="index"
              :to="`/chiromancy/${item.id}/`"
            >
              <img :src="require(`../assets/img/chiromancy/${item.id}.png`)" :alt="item.name">
              {{item.name}}
            </router-link>
          </nav>
        </transition>
      </div>
      <transition name="fade">
        <div class="overlay" v-if="openFirstMenu" @click="openFirstMenu = false"></div>
      </transition>
      <transition name="fade">
        <div class="overlay" v-if="openSecondMenu" @click="openSecondMenu = false"></div>
      </transition>
    </nav>
    <!-- /menu -->
    <div class="container" :class="{'sticky-next': sticky}">
      <Loader v-if="loading"/>
      <template v-else>
        <div class="dreambooks__breadcrumbs">Гадание по руке</div>
        <div class="row">
          <div class="col mb-3">
            <div class="dreambooks__img">
              <img src="../assets/img/chiromancy/chiromancy.png" alt="Гадание по руке">
            </div>
            <div class="dreambooks__text">
              <div v-html="chiromancyContent"></div>
            </div>
          </div>
        </div>

        <div class="row dreambooks__select-item">
          <div class="col">
            <div class="dreambooks__select-title dreambooks__select-title--gray">Выберите категорию</div>
            <div class="dreambooks__list dreambooks__list--gray dreambooks__list--nemu">
              <router-link
                v-for="(item, index) in chiromancySecondMenu"
                :key="index"
                :to="`/chiromancy/${item.id}/`"
              >
                <img :src="require(`../assets/img/chiromancy/${item.id}.png`)" :alt="item.name">
                {{item.name}}
              </router-link>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import setSticky from "../setSticky.js";
export default {
  components: {
    Loader
  },
  data() {
    return {
      openFirstMenu: false,
      openSecondMenu: false,
      sticky: false
    };
  },
  metaInfo () {
    return {
      title: 'Хиромантия - Гадание по руке - Линии руки и знаки на orakul.com',
      meta: [
        { name: 'description', content: 'Хиромантия, гадание по руке. Описание линий руки и холмов, значение и толкование знаков. Линия жизни, линия судьбы, линия брака, линия сердца, линия головы и т.д. Гадание по линиям рук, хиромантия на orakul.com' },
        { name: 'keywords', content: 'хиромантия, гадания по руке, херомантия, линии руки, линия жизни, знаки, линии хиромантия, линия брака, гадание' }
      ]
    }
  },
  computed: {
    firstMenu() {
      return this.$store.state.divination.firstMenu;
    },
    chiromancySecondMenu() {
      return this.$store.state.divination.chiromancySecondMenu;
    },
    chiromancyContent() {
      return this.$store.state.divination.chiromancyStartContent;
    },
    loading() {
      return this.$store.state.divination.loading;
    }
  },
  methods: {
    getContent() {
      this.$store.dispatch("divination/getChiromancyStartContent", {
        command: "getchiromancycontent"
      });
    }
  },
  created() {
    this.getContent();

    setSticky.call(this);
  }
};
</script>

<style lang="scss" scoped>
.horoscope-nav__item:first-child img {
  width: 74px;
}

.horoscope-menu a img {
  left: 7px;
}

.dreambooks__img {
  width: 160px;
  height: 160px;
  float: left;
  margin-right: 5px;
  margin-bottom: 5px;
  img {
    display: block;
    max-width: 100%;
    height: auto;
  }
}

.dreambooks__text {
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  color: #333;
  .link {
    font-weight: 400;
  }
}
.dreambooks__breadcrumbs {
  font-size: 18px;
  font-weight: 700;
  color: #000;
  margin-bottom: 20px;
}
.horoscope-menu--first a {
  width: 33%;
}
.horoscope-menu--second a {
  img {
    left: 0;
    border-radius: 50%;
  }
}

.dreambooks__select-title {
  padding: 20px 15px;
  font-size: 18px;
  font-weight: 700;
  line-height: 20px;
}

.dreambooks__select-title--gray {
  background: #f1f4f6;
  color: #333;
}

.dreambooks__select-item {
  margin-bottom: 25px;
}

.dreambooks__list {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 7px;
  width: 100%;
  overflow: hidden;
  &::after {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    content: "";
  }
  a {
    color: #511079;
    font-size: 18px;
    line-height: 18px;
    font-weight: 400;
    border: 2px solid transparent;
    display: block;
    text-align: center;
    width: calc(100% / 6);
    padding: 15px 3px;
    text-decoration: none;
    &:hover {
      text-decoration: none;
    }
    &.router-link-exact-active {
      color: #000;
      border-radius: 3px;
      border: 2px solid #ff00a4;
    }
    img {
      display: block;
      width: 50px;
      height: auto;
      margin: 0 auto;
      position: relative;
    }
  }
}

.dreambooks__list--nemu a {
  color: #777;
  font-size: 10px;
  line-height: 10px;
  font-weight: 700;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 33%;
  padding: 10px 3px;
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
  &.router-link-exact-active {
    color: #000;
    border-radius: 3px;
    border: 2px solid #ff00a4;
  }
  img {
    border-radius: 50%;
    box-shadow: 0 0 8px 4px #ccd6db;
    margin-bottom: 7px;
  }
}
.dreambooks__list--gray {
  background: #f1f4f6;
  &::after {
    box-shadow: 0 -80px 60px 60px #6d90a1;
  }
}
</style>

